import { NewsDetailItemFragment } from '@amf/shared/types/graphql';
import { NavigationProps } from '@amf/shared/utils/navigation';
import NewsDetailPage, { getServerSideProps as ssr } from '@amf/shared/pages/NewsDetailPage';

import Layout from 'components/layout/Layout';
import { AppLinks } from 'utils/links';
import Meta from 'components/Meta';

interface NewsDetailPageProps extends NavigationProps {
  news: NewsDetailItemFragment;
}

export default function Page({ news, navigation, partners }: NewsDetailPageProps) {
  return (
    <div className='NewsDetailPage'>
      <Layout navigation={navigation} partners={partners}>
        <Meta title={news.title} description={news.perex} image={news.photoUrl} type={'article'} />
        <NewsDetailPage news={news} prefixes={{ newsList: AppLinks.newsList }} />
      </Layout>
    </div>
  );
}

export const getServerSideProps = ssr;
